/*
 * @Author: zhang lin
 * @Date: 2022-08-22 16:14:17
 * @LastEditors: zhang lin
 * @LastEditTime: 2022-12-05 16:26:21
 */
import React, { useRef, useState, useImperativeHandle, forwardRef } from 'react';

import { useIntl } from 'react-intl';
import messages from './messages';
import { Button } from 'sup-ui';
import styles from './index.less';
import NoPackaege from 'root/components/NoPackage';
import InstallList from 'root/components/InstallList';
import { PackageDataType } from 'root/components/FileConfig/types';

const btnData = [
  {
    type: 'install',
    name: messages.install,
  },
  {
    type: 'upgrade',
    name: messages.upgrade,
  },
];

const ExtendedService = (props: any, ref: React.Ref<unknown> | undefined) => {
  const intl = useIntl();
  const listRef = useRef<any>(null);
  const [disabled, setDisabled] = useState<any>({});
  const [showNoSupos, setShowNoSupos] = useState<boolean>(false); // 显示未安装supos
  // 显示组件列表选择Modal
  const clickBtn = (type: string, catalog?: string) => {
    if (!listRef.current?.clickBtn) return;
    listRef.current?.clickBtn(type, catalog);
  };
  // 将子组件中值暴露给父组件
  useImperativeHandle(ref, () => ({
    clickBtn: clickBtn,
  }));

  // 安装状态改变
  const updateQueueChange = (queues: PackageDataType[]) => {
    const isFinish = queues.every((item) => item.status !== 'waiting' && !item.percent);
    const type = queues.find((item) => ['installing', 'waiting', 'upgrading', 'uninstalling'].includes(item.status))
      ?.type as string;

    const newDisabled = isFinish // 安装结束
      ? { install: false, upgrade: false }
      : type === 'uninstall' // 卸载中
      ? { install: true, upgrade: true }
      : { install: true, upgrade: true, [type]: false };

    // 当中间状态结束后 type为null
    if (!type) return setDisabled(false);

    if (JSON.stringify(newDisabled) === JSON.stringify(disabled)) return;
    return setDisabled(newDisabled);
  };

  const noSupos = (status: boolean) => {
    setShowNoSupos(status);
  };

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <h3 className={styles.title}>{intl.formatMessage(messages.extendedService)}</h3>
        <div>
          {btnData.length !== 0 &&
            btnData.map((btn) => {
              const { type, name } = btn;
              return (
                <Button
                  key={type}
                  className={styles.btn}
                  size="small"
                  onClick={() => clickBtn(type)}
                  // disabled={disabled[type]}
                  type="link"
                >
                  {intl.formatMessage(name)}
                </Button>
              );
            })}
        </div>
      </div>
      {showNoSupos && <NoPackaege />}
      <InstallList
        showExtendedService={true}
        ref={listRef}
        className={styles.list}
        updateQueueChange={updateQueueChange}
        noSuposCallback={noSupos}
        catalog="extension"
      />

      <div />
    </div>
  );
};

export default forwardRef(ExtendedService);
